var map = {
	"./1-1.svg": "8837",
	"./1-2.svg": "820f",
	"./1-3.svg": "280d",
	"./1-4.svg": "92d6",
	"./1-5.svg": "96f8",
	"./2-1.svg": "058e",
	"./2-2.svg": "d19c",
	"./2-3.svg": "1ffe",
	"./2-4.svg": "6964",
	"./2-5.svg": "7d4a",
	"./3-1.svg": "223a",
	"./3-2.svg": "d622",
	"./3-3.svg": "5d7d",
	"./3-4.svg": "c4af",
	"./3-5.svg": "72e2",
	"./4-1.svg": "7731",
	"./4-2.svg": "8f5b",
	"./4-3.svg": "e807",
	"./4-4.svg": "11a0",
	"./4-5.svg": "cb58",
	"./5-1.svg": "0121",
	"./5-2.svg": "c717",
	"./5-3.svg": "193b",
	"./5-4.svg": "831a",
	"./5-5.svg": "2fac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "20cd";